import { initializeApp } from "firebase/app";
import {
    getFirestore, collection, getDocs, getDoc, doc, query
} from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCbL0cm7227Aed1rl2NXjScwmeZp0ri6kg",
    authDomain: "testscoring-9eb91.firebaseapp.com",
    projectId: "testscoring-9eb91",
    storageBucket: "testscoring-9eb91.appspot.com",
    messagingSenderId: "679000192001",
    appId: "1:679000192001:web:edbe998dd4b3a24d2efc00"
}
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);






export {
    db, collection, getDocs, getDoc, doc, query
}